export default __webpack_public_path__ + "static/media/main-banner-class.f2db36c6.png";